import { NgModule } from '@angular/core';

import { SocialSigninService } from './social-signin.service';
import { CommonModule } from '@angular/common';
import { UserModule } from '../userService';

@NgModule({
    imports: [CommonModule, UserModule],
    exports: [],
    declarations: [],
    providers: [SocialSigninService]
})
export class SocialSigninModule {}
